<template>
  <div id="app">
    <mt-header fixed :title="pageTitle">
      <router-link to v-if="!showReturn && from !='/applySuccess'" slot="left">
        <mt-button @click="goBack()" icon="back"></mt-button>
      </router-link>

      <router-link to="/" v-if="from =='/applySuccess'" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>


      <!-- <mt-button icon="more" slot="right"></mt-button> -->
    </mt-header>
    <router-view/>
  </div>
</template>

<script>
  import qs from 'qs';

  export default {
    name: 'App',
    data() {
      return {
        from: '',
        showReturn: false,
        pageTitle: "首页",
        isiOS: 'android'
      }
    },
    mounted() {
      window.vue =this;
    },
    created() {
      const u = navigator.userAgent;
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    },
    watch: {
      $route: {
        handler(to, from) {
          this.from = this.$route.path;
          this.showReturn = to.path == '/index' || to.path == '/sendGood'
          this.pageTitle = to.meta.title
          if (from.path == '/sendGood' && to.path == "/checkResult") {
            this.showReturn = true
          }

          if(from.path == '/applySuccess' && to.path == '/perfectInfo') {
            let backlen=history.length-1;
            history.go(-backlen);
          }

          if(from.path == '/sendGood' && to.path == '/checkResult') {
             this.showReturn = true
          }
        },
        deep: true
      }
    },
    methods: {
      // 返回按钮事件
      goBack() {
        // 申请成功  点击左上返回  回到首页
        if (this.$route.path == "/applySuccess") {
          this.$router.push({path: '/index'})
        } else {
          // iso不兼容 router.go, 的使用history.go(-2) 不知道为啥是-2 而不是-1。。。。
          this.isiOS ? history.go(-2) : this.$router.go(-1);
        }
      }
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue